<template>
  <div>
    <v-dialog v-model="dialog.verif"
      @keydown.esc="dialog.verif = false"
      :fullscreen="dialog.fullscreen"
      width="750"
      persistent
      scrollable>
      <v-card class="border-radius pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
          <v-avatar size="35">
            <v-img
              contain
              width="30"
              height="30"
              alt="vuetify"
              :src="require('@/assets/logo/favicon.png')">
              <template v-slot:placeholder>
                <v-row
                  class="fill-height"
                  align="center"
                  justify="center">
                  <v-progress-circular 
                    indeterminate 
                    color="#2391d0">
                  </v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-avatar>

          <span class="mt-1 ml-1">
            Setujui / Tolak Ajuan
          </span>

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            color="#2391d0">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.verif = false"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>

        <v-divider class="mx-4 mt-3 mb-2"/>

        <Verification
          :detail="detail"
          @close="dialog.verif = $event; fetch();" />
      </v-card>
    </v-dialog>
    
    <v-row v-if="process.load && Object.keys(detail).length < 1">
      <v-col 
        cols="12" 
        md="3">
        <v-skeleton-loader
          :loading="process.load"
          type="list-item-avatar-three-line, article, list-item-avatar-three-line, list-item-avatar-three-line">
        </v-skeleton-loader>
      </v-col>

      <v-col 
        cols="12" 
        md="9">
        <v-skeleton-loader
          :loading="process.load"
          type="article, list-item-two-line, list-item-avatar-three-line, list-item-avatar-three-line, list-item-avatar-three-line, article, list-item-two-line, list-item-three-line">
        </v-skeleton-loader>
      </v-col>
    </v-row>

    <v-row v-if="!process.load && Object.keys(detail).length > 0"
      justify="center">
      <v-col 
        cols="12" 
        md="3"
        class="py-0">
        <v-card 
          color="white"
          class="box-shadow border-radius pa-3" 
          style="position: sticky; top: 85px;">
          <router-link
            to="/service/submission"
            class="d-flex align-center color-first cursor-pointer my-2"
            style="width: 35%;">
            <v-icon color="#2391d0">mdi-arrow-left-thick</v-icon>
        
            <span 
              class="body-1 black--text ml-1"
              style="opacity: 60%;">
              Kembali
            </span>
          </router-link>

          <v-list 
            flat 
            two-line 
            class="py-0">
            <v-list-item 
              class="px-0">
              <v-list-item-avatar 
                tile 
                size="50" 
                class="mr-3">
                <v-img 
                  style="border-radius: 10px;"
                  :src="detail.ajuan_pelapor_image === '' || detail.ajuan_pelapor_image === undefined ?  require('@/assets/image/member_default.jpg') : detail.ajuan_pelapor_image">
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height"
                      align="center"
                      justify="center">
                      <v-progress-circular 
                        indeterminate 
                        color="#2391d0">
                      </v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title 
                  class="body-1 text-capitalize font-weight-bold mb-2">
                    {{ detail.ajuan_pelapor_fullname }}
                </v-list-item-title>

                <v-list-item-subtitle 
                  class="body-2 text-capitalize font-weight-light">
                  <span 
                    class="color-first d-flex align-center">
                    <v-icon size="18" color="#2391d0">mdi-seal-variant</v-icon>

                    {{ detail.ajuan_pelapor_nik }}
                  </span>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>

          <v-divider 
            class="mb-3"
            style="border-top: 5px solid #f3f3f3; border-radius: 50px;" />

          <div
            v-for="(item, index) in menu"
            :key="index">
            <div 
              class="px-2">
              <div 
                class="body-1 font-weight-bold mb-4">
                {{ item.title }}
              </div>

              <div 
                v-for="(item_sub, index_sub) in item.sub_menu"
                :key="index_sub"
                @click="selected.menu = index; selected.sub_menu = index_sub; changeQuery(item_sub.link)"
                class="body-2 d-flex align-center cursor-pointer mb-4">
                <v-icon 
                  size="20"
                  class="mr-2"
                  :color="selected.menu === index && selected.sub_menu === index_sub ? '#2391d0' : '#7B7B7B'">
                  {{ item_sub.icon }}
                </v-icon>

                <span 
                  :class="selected.menu === index && selected.sub_menu === index_sub ? 'color-default font-weight-bold' : 'text-second'">
                  {{ item_sub.text }}
                </span>
              </div>
            </div>
          </div>

          <div v-if="detail.ajuan_status === 'MENUNGGU VERIFIKASI' || detail.ajuan_status === 'DIKOREKSI'">
            <v-btn 
              @click="save('DIPROSES')"
              :loading="process.form"
              :disabled="process.form"
              block
              elevation="0"
              class="body-2 font-weight-bold text-capitalize white--text"
              color="orange"
              style="border-radius: 10px;">
              <span
                class="ml-1">
                Periksa Berkas Ajuan ?
              </span>

              <v-spacer />

              <v-icon>mdi-timer-edit-outline</v-icon>
            </v-btn>
          </div>

          <div v-if="detail.ajuan_status === 'DIPROSES'">
            <v-btn
              @click="dialog.verif = true"
              :disabled="process.form"
              block
              elevation="0"
              class="body-2 font-weight-bold text-capitalize white--text"
              color="#2391d0"
              style="border-radius: 10px;">
              <span
                class="ml-1">
                Verifikasi Sekarang ?
              </span>

              <v-spacer />

              <v-icon>mdi-progress-check</v-icon>
            </v-btn>

            <div
              class="mt-4">
              <v-btn
                @click="save('MENUNGGU VERIFIKASI')"
                :loading="process.form"
                :disabled="process.form"
                block
                outlined
                elevation="0"
                class="body-2 font-weight-bold text-capitalize red--text"
                color="red"
                style="border-radius: 10px;">
                <span
                  class="ml-1">
                  Batalkan Periksa Ajuan
                </span>

                <v-spacer />

                <v-icon>mdi-close-thick</v-icon>
              </v-btn>
            </div>
          </div>
        </v-card>
      </v-col>

      <v-col 
        cols="12" 
        md="9"
        class="py-0"
        :class="detail.ajuan_status === 'MENUNGGU VERIFIKASI' || 
                detail.ajuan_status === 'DIKOREKSI' ? 'screen_disabled' : ''">
        <div>
          <Detail v-if="selected.menu === 0 && selected.sub_menu === 0"
            :detail="detail"
            @load="fetch()" />

          <Maping v-if="selected.menu === 0 && selected.sub_menu === 1"
            :detail="detail"
            @load="fetch()"  />

          <Attachment v-if="selected.menu === 0 && selected.sub_menu === 2"
            :detail="detail"
            @load="fetch()" />

          <Log v-if="selected.menu === 0 && selected.sub_menu === 3"
            :detail="detail"
            @load="fetch()" />
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "@/service/Axios";
  export default {
    data () {
      return {
        dialog: {
          fullscreen: false,
          verif: false
        },
        selected: {
          menu: 0,
          sub_menu: 0
        },
        menu: [
          {
            title: 'Ajuan Saya',
            sub_menu: []
          }
        ],
        detail: {},
        process: {
          load: false,
          form: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      Detail: () => import('@/components/submission/detail'),
      Maping: () => import('@/components/submission/maping'),
      Attachment: () => import('@/components/submission/attachment'),
      Log: () => import('@/components/submission/log'),

      Verification: () => import(/* webpackPrefetch: true */ '@/components/verification/dialog.vue')
    },
    computed: {
      
    },
    watch: {
      
    },
    beforeMount () {
      this.changeLink(this.$route.query.menu)
    },
    mounted () {
      this.fetch()
    },
    methods: {
      changeLink(query) {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
        
        if (query !== undefined) {
          if (query === 'detail') {
            this.selected = {
              menu: 0,
              sub_menu: 0
            }
          } else if (query === 'maping') {
            this.selected = {
              menu: 0,
              sub_menu: 1
            }
          } else if (query === 'attachment') {
            this.selected = {
              menu: 0,
              sub_menu: 2
            }
          } else if (query === 'log') {
            this.selected = {
              menu: 0,
              sub_menu: 3
            }
          }
        }
      },
      changeQuery(link) {
        this.$router.push(link)
      },
      async fetch () {
        this.process.load = true
        
        let params = {
          id: this.$route.params.id
        }

        await get(`ajuan/detail`, { params })
        .then(response => {
          let res = response.data

          this.process.load = false

          if (res.code === 200) {
            this.detail = res.data

            this.menu[0].sub_menu = [
              {
                text: 'Detail Ajuan',
                icon: 'mdi-file-document-multiple-outline',
                link: `/service/submission/${this.$route.params.id}?menu=detail`
              },
              {
                text: 'Maping',
                icon: 'mdi-map-marker-path',
                link: `/service/submission/${this.$route.params.id}?menu=maping`
              },
              {
                text: 'Lampiran',
                icon: 'mdi-paperclip',
                link: `/service/submission/${this.$route.params.id}?menu=attachment`
              },
              {
                text: 'Log Status',
                icon: 'mdi-list-status',
                link: `/service/submission/${this.$route.params.id}?menu=log`
              }
            ]
          }
        })
      },
      
      // PROSES VERIFIKASI
      async save (val) {
        this.message.error = ''

        this.process.form = true

        let forms = {
          id: this.detail.ajuan_id,
          status: val
        }

        // SAVE TO REST API
        await post('ajuan/update_status', {
          data: forms
        })
        .then((response) => {
          let res = response.data

          if (res.code === 200) {
            this.process.form = false
            
            this.fetch()
          } else {
            this.process.form = false
            this.message.error = res.message
          }
        })
      }
    }
  }
</script>